import { toRef } from "vue";
import { useFinderContribution } from "#ce/composables/useFinderContribution";
import { t } from "#ce/shared/components-i18n";

/**
 * Adapts the applied query and owner actions to the generic finder contribution contract.
 *
 * @param {object} options
 * @param {object} options.props - reactive omnisearch props
 * @param {ReturnType<import('./useEventsOmnisearchQuery').useEventsOmnisearchQuery>} options.query
 * @param {import('vue').ComputedRef<boolean>} options.editable
 * @param {() => void} options.reveal
 */
export function useEventsOmnisearchContribution({ props, query, editable, reveal }) {
  function clear() {
    if (query.appliedQuery.value && editable.value) {
      query.clearAppliedQuery();
    }
  }

  function describe() {
    const active = Boolean(query.appliedQuery.value);
    return {
      id: "query",
      label: props.queryLabel ?? t("finder_query_label"),
      icon: "search-filled",
      state: { active, withheld: !active, clearable: editable.value },
      actions: { clear, reveal: editable.value ? reveal : undefined },
    };
  }

  useFinderContribution({ target: toRef(props, "contributesTo"), describe });
}
